import React, {useState, useRef, useEffect} from "react";
import { Redirect, useParams } from 'react-router-dom';

import "./SsoLogin.css"

import SsoService from "../../services/sso.service";

const SsoLogin = () => {

    const { login } = useParams();
    const { password } = useParams();
    const { numeroCgos } = useParams();
    const { exercice } = useParams();

    useEffect(() => {
        loginUserMetier();
    }, []);

    const loginUserMetier = () => {
        SsoService.getSsoLogin(login, password, numeroCgos, exercice);
    };
  
    return (
        <div>
        </div>
    );
};

export default SsoLogin;
